import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMoveFloat12 from './IconMoveFloat12';
import IconMoveFloat16 from './IconMoveFloat16';
import IconMoveFloat20 from './IconMoveFloat20';
import IconMoveFloat24 from './IconMoveFloat24';
import IconMoveFloat32 from './IconMoveFloat32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMoveFloat = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMoveFloat12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMoveFloat16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMoveFloat20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMoveFloat24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMoveFloat32 {...props} />}
        </span>
    );
};
IconMoveFloat.displayName = 'FondueIconMoveFloat';

export default memo(IconMoveFloat);
